export enum ourGuaranteesPresets {
  SERVICE = 'SERVICE',
  SUBSCRIPTION = 'SUBSCRIPTION',
  PROSPECT = 'PROSPECT',
}

export type OurGuaranteesParentKeys = Extract<
  keyof IntlMessages['OurGuarantees'],
  string
>;
type OurGuaranteesNestedKeys = Extract<
  keyof IntlMessages['OurGuarantees'][OurGuaranteesParentKeys],
  string
>;

export type OurGuaranteesKeys =
  `${OurGuaranteesParentKeys}.${OurGuaranteesNestedKeys}`;
